export default {
    'modal.qd': '确定',
    'modal.qx': '取消',
    'modal.cg': '成功',
    'modal.sb': '失败'
}
